export enum NetxThemeMode {
	DEFAULT = 'default',
	DARK = 'dark',
	LIGHT = 'light',
}

export const NETX_THEME_MODES = Object.values(NetxThemeMode);

export enum NetxThemePref {
	USER_SELECTED = 'app:brand:mode',
}

export enum Severity {
	DEFAULT = 'default',
	ERROR = 'error',
	INFO = 'info',
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	SUCCESS = 'success',
	WARNING = 'warning',
}

export const SEVERITIES = Object.values(Severity);
